var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeChartMainPriceImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8155 1.37287C8.21427 0.91241 8.92859 0.91241 9.32736 1.37287L14.5615 7.41677C15.1224 8.06442 14.6624 9.07143 13.8056 9.07143H3.33725C2.4805 9.07143 2.02045 8.06442 2.58133 7.41677L7.8155 1.37287Z",
    fill: "#16D156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00448 19.4635L2.77031 13.4196C2.34965 12.9338 2.69469 12.1786 3.33725 12.1786L13.8056 12.1786C14.4482 12.1786 14.7932 12.9338 14.3725 13.4196L9.13837 19.4635C8.83929 19.8088 8.30356 19.8088 8.00448 19.4635Z",
    stroke: "#6B7C86",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeChartMainPriceImage1);
export default __webpack_public_path__ + "static/media/ExchangeChartMainPriceImage1.a7a208896ac4a671f2f0df1543b37957.svg";
export { ForwardRef as ReactComponent };